import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import config from 'config';
import getSetCookie from '../../../../cookie';
import { loadScriptWithCallback } from '../../../../utils/helper';
import './DittoPdpImageContainer.scss';

class DittoPdpImageContainer extends PureComponent {
  componentDidMount() {
    loadScriptWithCallback(
      'https://bsdk.api.ditto.com/default/5.1.0/en-in/api.js', () =>{
        if (getSetCookie.getCookie('isDittoID') !== '') {
          this.renderDitto(getSetCookie.getCookie('isDittoID'));
        }
      });
  }

  componentDidUpdate(prevProps) {
    const { dittoAuth } = this.props;
    if (prevProps.dittoAuth !== dittoAuth && dittoAuth) {
      this.renderDitto(getSetCookie.getCookie('isDittoID'));
    }
  }

  componentWillUnmount() {
    if (window.dittoTimeout) {
      clearTimeout(window.dittoTimeout);
    }
  }

  renderDitto = (dittoid, productId, isDittoEnabled) => {
    if (typeof window.tryOn === 'undefined') {
      if (dittoid !== '') this.renderDittoImage(dittoid, productId, isDittoEnabled);
    } else if (dittoid !== '') {
      this.renderDittoImage(dittoid, productId, isDittoEnabled);
    }
  };

  renderDittoImage = (dittoid, productId, isDittoEnabled) => {
    const { productData, section, loginStatus } = this.props;
    const dittoCheck = isDittoEnabled || productData.isDittoEnabled;
    if (dittoCheck && getSetCookie.getCookie('dittoSignature')) {
      if (window.dittoTimeout) {
        clearTimeout(window.dittoTimeout);
      }
      window.dittoTimeout = setTimeout(() => {
        let dittoThumbnailEl;
        let thumbnailSelectorId = '#all-ditto-thumbnail';
        if (!loginStatus) {
          dittoThumbnailEl = document.getElementById('ditto-thumbnail');
          thumbnailSelectorId = '#ditto-thumbnail';
        } else {
          dittoThumbnailEl = document.getElementById('all-ditto-thumbnail');
        }
        if (dittoThumbnailEl) {
          dittoThumbnailEl.innerHTML = '';
          window.tryOn = new window.Ditto.Overlay(
            {
              tryOnServer: config.ditto.serverUrl,
              partnerId: 'lenskart',
              domSelector:
                section === 'cat' || section === 'prod' ? '#ditto' : '.dittoContainer_ditto',
              thumbnailSelector: thumbnailSelectorId,
              scanId: dittoid,
              glassesId: productId || productData.id,
              accessKey: getSetCookie.getCookie('dittoAccessID'),
              overlaySignature: getSetCookie.getCookie('dittoSignature'),
            },
            {
              success: () => {
                _gaq.push(
                  ['_trackEvent', 'Ditto', 'DCF Success', `${productData.type};${productData.id}`],
                  [
                    'ninja._trackEvent',
                    'Ditto',
                    'DCF Success',
                    `${productData.type};${productData.id}`,
                  ]
                );
              },
              failure: () => {},
            }
          );
        }
      }, 200);
    }
  };

  render() {
    return (
      <div className="dittoThumbnails">
        <div className="dittoThumbnails_child" id="all-ditto-thumbnail" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dittoAuth: state.common.dittoAuth,
  section: state.common.section,
});

export default connect(mapStateToProps)(DittoPdpImageContainer);
